const initialState = {
    id: null,
}

export default (state = initialState) => (state)



// WEBPACK FOOTER //
// ./state/reducers/CMT/Account.js